<template>
  <v-data-table
    :headers="headers"
    :items="history"
  >
    <template v-slot:item.updatedAt="{ item }">
      {{ $options.filters.formatDate(item.updatedAt, ('L LT')) }}
    </template>
    <template v-slot:item.updatedBy="{ item }">
      {{ item.updatedBy.user.profile.firstName }} {{ item.updatedBy.user.profile.lastName }}
    </template>
  </v-data-table>
</template>

<script>


export default {
    name: 'HistoryTable',
    props: {
        history: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            headers: [
                { text: this.$t('technicalFile.boiler.step4.name'), value: 'updatedBy' },
                { text: this.$t('technicalFile.boiler.step4.date'), value: 'updatedAt' },
                { text: this.$t('technicalFile.boiler.step4.action'), value: 'action' },
            ],
        };
    },
};
</script>
